import { useCallback, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEventListener } from '../useEventListener';
export function useShellHistoryListener() {
    const navigate = useNavigate();
    const location = useLocation();
    const shellHistoryChangeHandler = useCallback((event) => {
        if (location.pathname !== event.detail.pathname) {
            navigate({
                pathname: event.detail.pathname,
                search: event.detail.search,
                hash: event.detail.hash
            });
        }
    }, [location, navigate]);
    useEventListener('clubhistorychange', shellHistoryChangeHandler);
    useEffect(function dispatchHistoryChangeEvent() {
        window.dispatchEvent(new CustomEvent('contenthistorychange', {
            detail: {
                pathname: location.pathname,
                search: location.search,
                hash: location.hash
            }
        }));
    }, [location]);
}
